module.exports = [{
      plugin: require('/home/runner/work/cm-nissan-nna-nissan-dealers/cm-nissan-nna-nissan-dealers/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
